import React from 'react';
import { NavLink } from 'react-router-dom';
const CryptoStep3 = ({ setCurrentStep, rateData }) => {

   if (!rateData) {
      // Muestra un mensaje si no hay datos, por si se llega aquí por error
      return <div className="modal_content_body text-center">No order details found.</div>;
   }

   // Formatear fecha y hora actual
   const orderDate = new Date().toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
   });

   return (
      <div className="modal_content_body text-center">
         <h3 className="ppt_form_title mb-4 text-center">Crypto payment by <img src={process.env.PUBLIC_URL + '/assets/img/logo_fpay.svg'} alt="" className='ps-2' /></h3>
         <div className='ppt_deposit_item'>
            <img
               src={process.env.PUBLIC_URL + '/assets/img/icon_check.svg'}
               alt=""
               style={{ width: '100px' }}
               className="d-block mb-2 mx-auto"
            />
            <p className="col-lg-10 mx-lg-auto mb-2">
               <strong className='d-block mb-2'>Order confirmed!</strong>
               Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.
            </p>

            <div className='ppt_deposit_item gap-1 py-3' style={{ backgroundColor: '#E0E0E0' }}>
               <strong className='d-block'>Order details</strong>
               <small>
                  Order ID: {rateData.payment_id}<br />
                  Payment amount: ${parseFloat(rateData.invoice_amount).toFixed(2)}<br />
                  Token amount ordered: {parseFloat(rateData.amount).toFixed(4)} {rateData.currency}<br />
                  **Estimated wait time: {rateData.wait_time}**<br />
                  Date & Time of order: {orderDate}
               </small>
            </div>

            <div className="d-flex justify-content-center gap-3 pt-2">
               <small><strong>For any inquiry on your order's status please contact sales at <NavLink className='t-anchor' to='tel:+18242585211'><u>+1 824 258 5211</u></NavLink> or use the <NavLink className='t-anchor' to=''><u>chat bot</u></NavLink>.</strong></small>
            </div>
         </div>
         <small
            className="t-anchor mt-4 d-block pointer"
            onClick={() => setCurrentStep(4)}
         >
            [view "Payment failed" screen]
         </small>
      </div>
   );
};
export default CryptoStep3;